import { DomComponentHander } from "./Handler";
const SESSION_KEY = "require_hide_button";
const REQUIRE_HIDE_VAL = "1";
export class HideButtonNoReferer extends DomComponentHander {
    static DomContentLoaded() {
        const href = location.href;
        const referer = document.referrer;
        // 直接のアクセス、もしくは自ドメインからの遷移を判定
        const condition = (referer.length === 0 || href.lastIndexOf(referer) > -1) === true ? "1" : "0";
        console.debug(`href => ${href}, referer => ${referer}`);
        // 保持した値を取得
        let requireHide = sessionStorage.getItem(SESSION_KEY);
        // なければ詰める
        if (requireHide === null) {
            sessionStorage.setItem(SESSION_KEY, condition);
            requireHide = condition;
        }
        // 非表示にする必要があれば非表示に
        if (REQUIRE_HIDE_VAL === requireHide) {
            document.querySelectorAll('.HideNoReferer').forEach(elm => {
                elm.classList.add('is-hidden');
            });
        }
    }
}
